module.exports = __webpack_public_path__ + "img/pinInClick.a139e5cc.png";